<script>
import {performanceConfig_detailList, performanceConfig_updateOther, performanceStaffInfo_list} from "@/lib/request";
import {getLocalItem, setLocalItem} from "@/untils/common";
export default {
  name: 'centerSet',
  data() {
    return {
      submitFlag: true,
      showFlag: false,
      current: 0,
      allCheck: false,
      showMonthFlag: false,
      showMonthValue: '',
      showReviewValue: '',
      showAreaValue: '',
      areaShow: false,
      showAreaFlag:false,
      areaItemList: [],
      areaList: [
        {name: '拉萨市'},
        // {name: '日喀则市'},
        // {name: '昌都市'},
        {name: '阿里地区'},
        {name: '山南市'},
        {name: '那曲市'},
        {name: '林芝市'}
      ],
      monthList: [
        {name: ''},
        {name: ''},
      ],
      userArrData: [],
      useObj: [],
      userWorkList: [
        // {
        //   "id":1,
        //   "name":'张三',
        //   "otherAddScore": "0.00",
        //   "otherAddMoney": "200.00",
        //   "otherAddRemark": null,
        //   "otherMinusScore": "-10.00",
        //   "otherMinusMoney": "0.00",
        //   "otherMinusRemark": null,
        // },{
        //   "id":2,
        //   "name":'李四',
        //   "otherAddScore": "10.00",
        //   "otherAddMoney": "20.00",
        //   "otherAddRemark": null,
        //   "otherMinusScore": "-40.00",
        //   "otherMinusMoney": "0.00",
        //   "otherMinusRemark": null,
        // },{
        //   "id":3,
        //   "name":'王五',
        //   "otherAddScore": "15.00",
        //   "otherAddMoney": "30.00",
        //   "otherAddRemark": null,
        //   "otherMinusScore": "-20.00",
        //   "otherMinusMoney": "0.00",
        //   "otherMinusRemark": null,
        // }
      ]
    }
  },
  components: {},
  watch: {
    // 监控参数变化
    searchParams(newVal, oldVal) {
      // if (newVal.category !== oldVal.category) {
      //   this.page1 = 1;
      // }
      this.getListData();
    },
  },
  computed: {
    // 监控参数变化更新
    searchParams() {
      return {
        "month": this.showMonthValue,
        "city": this.showReviewValue,
        "area": this.showAreaValue,
      }
    },
  },
  created() {
    if (getLocalItem('deptName')) {
      if (getLocalItem('deptName').split('-') && getLocalItem('deptName').split('-').length > 0) {
        if (getLocalItem('deptName').split('-')[1]) {
          // 地市
          this.showReviewValue = getLocalItem('deptName').split('-')[0];
          // 片区
          this.showAreaValue = getLocalItem('deptName').split('-')[1];
          // 如果this.showReviewValue='拉萨市'
          this.areaShow = true;
        } else {
          // 地市
          this.showReviewValue = getLocalItem('deptName');
          // 片区
          this.showAreaValue = '';
        }
        if(this.showReviewValue==='拉萨市'){
          this.areaShow = true;
          this.areaItemList = [
            {name: '东郊片区'},
            {name: '北郊片区'},
            {name: '柳梧片区'},
            {name: '堆龙片区'},
          ]
          this.showAreaValue = this.areaItemList[0].name;
        }
        // else if(this.showReviewValue==='林芝市'){
        //   this.areaShow = true;
        //   this.areaItemList = [
        //     {name: '一片区'},
        //     {name: '二片区'},
        //     {name: '三片区'},
        //     {name: '四片区'},
        //   ]
        //   this.showAreaValue = this.areaItemList[0].name;
        // }
      }
    }
    // 获取本月
    const d = new Date();
    this.monthList[0].name = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
    // 上个月的日期
    this.monthList[1].name = this.getLastMonth();
    this.showMonthValue = this.monthList[0].name;
  },
  methods: {

    getAddMoney(item){
      item.otherAddMoney++
    },

    getRemoveMoney(item){
      if(!item.otherMinusMoney){
        this.$toast('请先设置数据');
        return false;
      }
      if(item.otherMinusMoney>0) {
        item.otherMinusMoney--;
      }
    },
    getAddScore(item){
      item.otherAddScore++
    },
    getRemoveScore(item){
      if(!item.otherMinusScore){
        this.$toast('请先设置数据');
        return false;
      }
      if(item.otherMinusScore>0){
        item.otherMinusScore--;
      }
    },
    //
    onInput(item) {
      // console.log(val)
      // console.log(index)
      // console.log(val.replace(/[^0-9.]/g, '').replace(/(\.\d\d).*/g, '$1'))
      // 限制小数点后两位
      // return item.otherAddMoney.replace(/[^0-9.]/g, '').replace(/(\.\d\d).*/g, '$1');
    },
    getLastMonth() {
      const today = new Date();
      let lastMonth = new Date(today);
      lastMonth.setMonth(lastMonth.getMonth() - 1); // 减去一个月

      let year = lastMonth.getFullYear(); // 获取年份
      let month = lastMonth.getMonth() + 1; // 获取月份，月份是从0开始的，所以要加1

      // 格式化月份为两位数
      month = month < 10 ? '0' + month : month;

      return `${year}-${month}`;
    },
    getListData(type) {
      if (!this.searchParams.month) {
        console.log('month')
        return false;
      }
      if (!this.searchParams.city) {
        console.log('city')
        return false;
      }
      if (this.searchParams.city === '拉萨市') {
        if (!this.searchParams.area) {
          console.log('area')
          return false;
        }
      }
      console.log(this.searchParams);
      // this.userWorkList = [
      //   {
      //     "id": "2007715568123121665",
      //     "staffId": "1958128303879028737",
      //     "month": "2026-01",
      //     "city": "拉萨市",
      //     "area": "北郊片区",
      //     "name": "尼玛次仁",
      //     "instantActualSales": null,
      //     "computerActualSales": null,
      //     "siteCount": null,
      //     "lowPerformanceSiteCount": null,
      //     "highPerformanceSiteCount": null,
      //     "newSiteCount": null,
      //     "visitCount": null,
      //     "noSalesSiteCount": null,
      //     "commendation": 1,
      //     "overdueTaskCount": 3,
      //     "lateTaskCount": null,
      //     "violationCount": 2,
      //     "badImageSiteCount": null,
      //     "salesViolationSiteCount": 3,
      //     "complaintTimeoutCount": 5,
      //     "dishonestCount": 1,
      //     "poorCooperationCount": 2,
      //     "majorRisk": 1,
      //     "attendanceDays": null,
      //     "leaveDays": null,
      //     "absentDays": null,
      //     "holidayDays": 0,
      //     "secondedDays": 0,
      //     "totalAttendanceDays": null,
      //     "otherAddScore": "2",
      //     "otherMinusScore": "-4",
      //     "otherAddMoney": "1",
      //     "otherMinusMoney": "-3",
      //     "otherAddRemark": "",
      //     "otherMinusRemark": "",
      //     "satisfactionDegree": null
      //   },
      //   {
      //     "id": "2007715568504803329",
      //     "staffId": "1958128414340218881",
      //     "month": "2026-01",
      //     "city": "拉萨市",
      //     "area": "东郊片区",
      //     "name": "周兵兵",
      //     "instantActualSales": null,
      //     "computerActualSales": null,
      //     "siteCount": null,
      //     "lowPerformanceSiteCount": null,
      //     "highPerformanceSiteCount": null,
      //     "newSiteCount": null,
      //     "visitCount": null,
      //     "noSalesSiteCount": null,
      //     "commendation": 1,
      //     "overdueTaskCount": 3,
      //     "lateTaskCount": null,
      //     "violationCount": 2,
      //     "badImageSiteCount": null,
      //     "salesViolationSiteCount": 3,
      //     "complaintTimeoutCount": 5,
      //     "dishonestCount": 1,
      //     "poorCooperationCount": 2,
      //     "majorRisk": 1,
      //     "attendanceDays": null,
      //     "leaveDays": null,
      //     "absentDays": null,
      //     "holidayDays": 0,
      //     "secondedDays": 0,
      //     "totalAttendanceDays": null,
      //     "otherAddScore": "2",
      //     "otherMinusScore": "-4",
      //     "otherAddMoney": "1",
      //     "otherMinusMoney": "-3",
      //     "otherAddRemark": null,
      //     "otherMinusRemark": null,
      //     "satisfactionDegree": null
      //   },
      //   {
      //     "id": "2007715568899067905",
      //     "staffId": "1958128519382368258",
      //     "month": "2026-01",
      //     "city": "拉萨市",
      //     "area": "柳梧片区",
      //     "name": "索朗旺姆",
      //     "instantActualSales": null,
      //     "computerActualSales": null,
      //     "siteCount": null,
      //     "lowPerformanceSiteCount": null,
      //     "highPerformanceSiteCount": null,
      //     "newSiteCount": null,
      //     "visitCount": null,
      //     "noSalesSiteCount": null,
      //     "commendation": 1,
      //     "overdueTaskCount": 3,
      //     "lateTaskCount": null,
      //     "violationCount": 2,
      //     "badImageSiteCount": null,
      //     "salesViolationSiteCount": 3,
      //     "complaintTimeoutCount": 5,
      //     "dishonestCount": 1,
      //     "poorCooperationCount": 2,
      //     "majorRisk": 1,
      //     "attendanceDays": null,
      //     "leaveDays": null,
      //     "absentDays": null,
      //     "holidayDays": 0,
      //     "secondedDays": 0,
      //     "totalAttendanceDays": null,
      //     "otherAddScore": "2",
      //     "otherMinusScore": "-4",
      //     "otherAddMoney": "1",
      //     "otherMinusMoney": "-3",
      //     "otherAddRemark": null,
      //     "otherMinusRemark": null,
      //     "satisfactionDegree": null
      //   },
      //   {
      //     "id": "2007715569268166657",
      //     "staffId": "1958128618502160386",
      //     "month": "2026-01",
      //     "city": "拉萨市",
      //     "area": "堆龙片区",
      //     "name": "旦真",
      //     "instantActualSales": null,
      //     "computerActualSales": null,
      //     "siteCount": null,
      //     "lowPerformanceSiteCount": null,
      //     "highPerformanceSiteCount": null,
      //     "newSiteCount": null,
      //     "visitCount": null,
      //     "noSalesSiteCount": null,
      //     "commendation": 1,
      //     "overdueTaskCount": 3,
      //     "lateTaskCount": null,
      //     "violationCount": 2,
      //     "badImageSiteCount": null,
      //     "salesViolationSiteCount": 3,
      //     "complaintTimeoutCount": 5,
      //     "dishonestCount": 1,
      //     "poorCooperationCount": 2,
      //     "majorRisk": 1,
      //     "attendanceDays": null,
      //     "leaveDays": null,
      //     "absentDays": null,
      //     "holidayDays": 0,
      //     "secondedDays": 0,
      //     "totalAttendanceDays": null,
      //     "otherAddScore": "2",
      //     "otherMinusScore": "-4",
      //     "otherAddMoney": "1",
      //     "otherMinusMoney": "-3",
      //     "otherAddRemark": null,
      //     "otherMinusRemark": null,
      //     "satisfactionDegree": null
      //   },
      //   {
      //     "id": "2007715570052501506",
      //     "staffId": "1958128723586252802",
      //     "month": "2026-01",
      //     "city": "拉萨市",
      //     "area": "北郊片区",
      //     "name": "果吉",
      //     "instantActualSales": null,
      //     "computerActualSales": null,
      //     "siteCount": null,
      //     "lowPerformanceSiteCount": null,
      //     "highPerformanceSiteCount": null,
      //     "newSiteCount": null,
      //     "visitCount": null,
      //     "noSalesSiteCount": null,
      //     "commendation": 1,
      //     "overdueTaskCount": 3,
      //     "lateTaskCount": null,
      //     "violationCount": 2,
      //     "badImageSiteCount": null,
      //     "salesViolationSiteCount": 3,
      //     "complaintTimeoutCount": 5,
      //     "dishonestCount": 1,
      //     "poorCooperationCount": 2,
      //     "majorRisk": 1,
      //     "attendanceDays": null,
      //     "leaveDays": null,
      //     "absentDays": null,
      //     "holidayDays": 0,
      //     "secondedDays": 0,
      //     "totalAttendanceDays": null,
      //     "otherAddScore": "2",
      //     "otherMinusScore": "-4",
      //     "otherAddMoney": "1",
      //     "otherMinusMoney": "-3",
      //     "otherAddRemark": null,
      //     "otherMinusRemark": null,
      //     "satisfactionDegree": null
      //   },
      //   {
      //     "id": "2007715570421600257",
      //     "staffId": "1958128857455853569",
      //     "month": "2026-01",
      //     "city": "拉萨市",
      //     "area": "堆龙片区",
      //     "name": "吴树美",
      //     "instantActualSales": null,
      //     "computerActualSales": null,
      //     "siteCount": null,
      //     "lowPerformanceSiteCount": null,
      //     "highPerformanceSiteCount": null,
      //     "newSiteCount": null,
      //     "visitCount": null,
      //     "noSalesSiteCount": null,
      //     "commendation": 1,
      //     "overdueTaskCount": 3,
      //     "lateTaskCount": null,
      //     "violationCount": 2,
      //     "badImageSiteCount": null,
      //     "salesViolationSiteCount": 3,
      //     "complaintTimeoutCount": 5,
      //     "dishonestCount": 1,
      //     "poorCooperationCount": 2,
      //     "majorRisk": 1,
      //     "attendanceDays": null,
      //     "leaveDays": null,
      //     "absentDays": null,
      //     "holidayDays": 0,
      //     "secondedDays": 0,
      //     "totalAttendanceDays": null,
      //     "otherAddScore": "2",
      //     "otherMinusScore": "-4",
      //     "otherAddMoney": "1",
      //     "otherMinusMoney": "-3",
      //     "otherAddRemark": null,
      //     "otherMinusRemark": null,
      //     "satisfactionDegree": null
      //   },
      //   {
      //     "id": "2007715570799087617",
      //     "staffId": "1958128989047947266",
      //     "month": "2026-01",
      //     "city": "拉萨市",
      //     "area": "东郊片区",
      //     "name": "普布旦增",
      //     "instantActualSales": null,
      //     "computerActualSales": null,
      //     "siteCount": null,
      //     "lowPerformanceSiteCount": null,
      //     "highPerformanceSiteCount": null,
      //     "newSiteCount": null,
      //     "visitCount": null,
      //     "noSalesSiteCount": null,
      //     "commendation": 1,
      //     "overdueTaskCount": 3,
      //     "lateTaskCount": null,
      //     "violationCount": 2,
      //     "badImageSiteCount": null,
      //     "salesViolationSiteCount": 3,
      //     "complaintTimeoutCount": 5,
      //     "dishonestCount": 1,
      //     "poorCooperationCount": 2,
      //     "majorRisk": 1,
      //     "attendanceDays": null,
      //     "leaveDays": null,
      //     "absentDays": null,
      //     "holidayDays": 0,
      //     "secondedDays": 0,
      //     "totalAttendanceDays": null,
      //     "otherAddScore": "2",
      //     "otherMinusScore": "-4",
      //     "otherAddMoney": "1",
      //     "otherMinusMoney": "-40.77",
      //     "otherAddRemark": null,
      //     "otherMinusRemark": null,
      //     "satisfactionDegree": null
      //   },
      //   {
      //     "id": "2007715577841324033",
      //     "staffId": "1961316091861053442",
      //     "month": "2026-01",
      //     "city": "拉萨市",
      //     "area": "北郊片区",
      //     "name": "赵建军",
      //     "instantActualSales": null,
      //     "computerActualSales": null,
      //     "siteCount": null,
      //     "lowPerformanceSiteCount": null,
      //     "highPerformanceSiteCount": null,
      //     "newSiteCount": null,
      //     "visitCount": null,
      //     "noSalesSiteCount": null,
      //     "commendation": 1,
      //     "overdueTaskCount": 3,
      //     "lateTaskCount": null,
      //     "violationCount": 2,
      //     "badImageSiteCount": null,
      //     "salesViolationSiteCount": 3,
      //     "complaintTimeoutCount": 5,
      //     "dishonestCount": 1,
      //     "poorCooperationCount": 2,
      //     "majorRisk": 1,
      //     "attendanceDays": null,
      //     "leaveDays": null,
      //     "absentDays": null,
      //     "holidayDays": 0,
      //     "secondedDays": 0,
      //     "totalAttendanceDays": null,
      //     "otherAddScore": "2",
      //     "otherMinusScore": "-4",
      //     "otherAddMoney": "1",
      //     "otherMinusMoney": "-3",
      //     "otherAddRemark": null,
      //     "otherMinusRemark": null,
      //     "satisfactionDegree": null
      //   },
      //   {
      //     "id": "2007715579904921601",
      //     "staffId": "2001953938499616770",
      //     "month": "2026-01",
      //     "city": "拉萨市",
      //     "area": "柳梧片区",
      //     "name": "曲桑",
      //     "instantActualSales": null,
      //     "computerActualSales": null,
      //     "siteCount": null,
      //     "lowPerformanceSiteCount": null,
      //     "highPerformanceSiteCount": null,
      //     "newSiteCount": null,
      //     "visitCount": null,
      //     "noSalesSiteCount": null,
      //     "commendation": 1,
      //     "overdueTaskCount": 3,
      //     "lateTaskCount": null,
      //     "violationCount": 2,
      //     "badImageSiteCount": null,
      //     "salesViolationSiteCount": 3,
      //     "complaintTimeoutCount": 5,
      //     "dishonestCount": 1,
      //     "poorCooperationCount": 2,
      //     "majorRisk": 1,
      //     "attendanceDays": null,
      //     "leaveDays": null,
      //     "absentDays": null,
      //     "holidayDays": 0,
      //     "secondedDays": 0,
      //     "totalAttendanceDays": null,
      //     "otherAddScore": "2",
      //     "otherMinusScore": "-4",
      //     "otherAddMoney": "1",
      //     "otherMinusMoney": "-3.90",
      //     "otherAddRemark": null,
      //     "otherMinusRemark": null,
      //     "satisfactionDegree": null
      //   }
      // ]
      // this.userWorkList.map((v)=>{
      //   if(Number(v.otherMinusMoney)<0){
      //     v.otherMinusMoney = v.otherMinusMoney.substring(1,v.otherMinusMoney.length);
      //   }
      //   if(Number(v.otherMinusScore)<0){
      //     v.otherMinusScore = v.otherMinusScore.substring(1,v.otherMinusScore.length);
      //   }
      // })
      // this.useObj = [this.userWorkList[0]];
      // return false;
      performanceStaffInfo_list(this.searchParams).then((res) => {
        if (res) {
          if (!res.data) {
            this.$toast('暂无数据！');
            return false;
          }
          // if(res.data.code===200){
          console.log(res.data);
          if (res.data.length > 0) {
            res.data.map((v) => {
              if (v.otherAddScore) {
                v.otherAddScore = Number(v.otherAddScore);
                if (v.otherAddScore === 0) {
                  v.otherAddScore = null
                }
              }
              if (v.otherAddMoney) {
                v.otherAddMoney = Number(v.otherAddMoney)
                if (v.otherAddMoney === 0) {
                  v.otherAddMoney = null
                }
              }
              if (v.otherMinusScore) {
                v.otherMinusScore = Number(v.otherMinusScore)
                if (v.otherMinusScore === 0) {
                  v.otherMinusScore = null
                } else {
                  if (v.otherMinusScore < 0) {
                    v.otherMinusScore = v.otherMinusScore.toString().substring(1, v.otherMinusScore.length);
                  }
                }
              }
              if (v.otherMinusMoney) {
                v.otherMinusMoney = Number(v.otherMinusMoney)
                if (v.otherMinusMoney === 0) {
                  v.otherMinusMoney = null
                } else {
                  if (v.otherMinusMoney < 0) {
                    v.otherMinusMoney = v.otherMinusMoney.toString().substring(1, v.otherMinusMoney.length);
                  }
                }
              }
            });
            this.userWorkList = res.data;
            if (type) {
              console.log(this.current)
              this.useObj = [this.userWorkList[this.current]];
            } else {
              this.useObj = [this.userWorkList[0]];
            }
          }
          // console.log(res.data.data);
          // if(res.data.data.length<=0){
          //   // this.$toast('数据为空！');
          //   return false;
          // }
          // }
        }
      });
    },
    getOnNumberTime(item, type) {
      // console.log(type,item)
      if (this.isRestoring) return;
      this.isRestoring = true;
      // 延时确保在键盘完全收起后执行
      setTimeout(() => {
        window.scrollTo({
          top: this.savedScrollPosition,
          behavior: 'smooth' // 平滑滚动，可选
        });
        this.isRestoring = false;
      }, 300); // 这个时间可以根据需要调整，通常200-400ms
    },
    saveScrollPosition() {
      this.savedScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    },
    getTab(item, index) {
      this.current = index;
      this.useObj = [item];
    },

    // 片区
    onAreaItemType(value) {
      this.showAreaValue = value.name;
      this.showAreaFlag = false;
    },
    // 月份
    onMonthType(value) {
      this.showMonthValue = value.name;
      this.showMonthFlag = false;
    },
    //   提交
    getCommit() {
      console.log('全部数据', this.userWorkList)
      this.allCheck = false;
      let arr = [];
      let arrRem = [];
      this.userWorkList.map((v) => {
        if (v.otherMinusMoney || v.otherAddMoney || v.otherAddScore || v.otherMinusScore) {
          arr.push(v)
        }
        if (!v.otherMinusMoney && !v.otherAddMoney && !v.otherAddScore && !v.otherMinusScore) {
          arrRem.push(v)
        }
      });
      console.log(arrRem.length)
      if (arrRem.length === this.userWorkList.length) {
        console.log('1111')
        this.$toast('请输入信息');
        return false;
      } else {
        console.log('222')
        this.userWorkList.map((v) => {
          if (v.otherMinusMoney > 0) {
            v.otherMinusMoney = '-' + v.otherMinusMoney;
          }
          if (v.otherMinusScore > 0) {
            v.otherMinusScore = '-' + v.otherMinusScore;
          }
          if (!v.otherMinusMoney) {
            v.otherMinusMoney = 0;
          }
          if (!v.otherAddMoney) {
            v.otherAddMoney = 0;
          }
          if (!v.otherAddScore) {
            v.otherAddScore = 0;
          }
          if (!v.otherMinusScore) {
            v.otherMinusScore = 0;
          }
          if (!v.otherAddRemark) {
            v.otherAddRemark = '';
          }
          if (!v.otherMinusRemark) {
            v.otherMinusRemark = '';
          }
        });
        this.showFlag = true;
      }
    },
    getLastSubmitIng() {
      if (!this.submitFlag) {
        this.$toast('数据正在提交，请勿重复操作！');
        return false;
      }
    },
    getLastSubmit() {
      this.submitFlag = false;
      if (this.userWorkList.length === 0) {
        this.$toast('无数据');
        return false;
      }
      performanceConfig_updateOther(this.userWorkList).then((res) => {
        if (res) {
          this.submitFlag = true;
          if (!res.data) {
            this.$toast('res.data不存在');
            return false
          }
          if (res.data.code === 200) {
            this.showFlag = false;
            // this.current = 0;
            this.getListData('current');
            this.$toast.success('设置成功！');
          } else {
            this.$toast.success(res.data.msg);
          }
        }
      });
    },
    // 一键清除
    getDelCommit() {
      // this.current = 0;
      this.allCheck = false;
      this.userWorkList.map((v) => {
        v.otherAddMoney = null;
        v.otherAddScore = null;
        v.otherAddRemark = null;
        v.otherMinusMoney = null;
        v.otherMinusScore = null;
        v.otherMinusRemark = null;
      });
      this.$toast.success(`清空全部的设置数据！`);
    },
    //   一键统一
    getOneCommit() {
      // this.userWorkList
      // console.log(this.useObj)
      // const eField1 = this.userWorkList.find(item => !item.otherAddMoney);
      // const eField2 = this.userWorkList.find(item => !item.otherAddScore);
      // const eField3 = this.userWorkList.find(item => !item.otherMinusMoney);
      // const eField4 = this.userWorkList.find(item => !item.otherMinusScore);
      // console.log(eField1)
      // console.log(eField2)
      // console.log(eField3)
      // console.log(eField4)
      console.log(this.current)
      // this.current = null;
      if (this.current >= 0) {
        this.userWorkList.map((v) => {
          v.otherAddMoney = this.userWorkList[this.current].otherAddMoney;
          v.otherAddScore = this.userWorkList[this.current].otherAddScore;
          v.otherAddRemark = this.userWorkList[this.current].otherAddRemark;
          v.otherMinusMoney = this.userWorkList[this.current].otherMinusMoney;
          v.otherMinusScore = this.userWorkList[this.current].otherMinusScore;
          v.otherMinusRemark = this.userWorkList[this.current].otherMinusRemark;
        })
        if (this.userWorkList[this.current].otherAddMoney || this.userWorkList[this.current].otherAddScore) {

        } else if (this.userWorkList[this.current].otherMinusMoney || this.userWorkList[this.current].otherMinusScore) {

        } else {
          this.$toast(`请输入信息！`);
          return false;
        }
        this.allCheck = true;
        this.$toast.success(`设置全部的统一数据！`);
      }
    },
  }
}
</script>

<template>
  <div class="tech-content-no">
    <!--    基本信息    -->
    <div class="card">
      <div class="label-title">
        <van-icon name="info-o"/>
        基本信息
      </div>
      <div class="stack-group">
        <div class="t-bound">
          <div class="t-bound-e">月份<span>*</span></div>
          <div class="t-bound-t">
            <van-field
                v-model="showMonthValue"
                name=""
                label=""
                readonly="readonly"
                placeholder="请选择月份"
                @click="showMonthFlag=true"
            >
              <template #right-icon>
                <van-icon name="arrow-down"/>
              </template>
            </van-field>
          </div>
        </div>
        <div class="t-bound">
          <div class="t-bound-e">地市<span>*</span></div>
          <div class="t-bound-t">
            <van-field
                v-model="showReviewValue"
                name=""
                label=""
                readonly="readonly"
                placeholder="请选择地市"
            >
              <template #right-icon>
                <!--                <van-icon name="arrow-down"/>-->
              </template>
            </van-field>
          </div>
        </div>
      </div>
      <div class="stack-group" v-if="areaShow">
        <div class="t-bound">
          <div class="t-bound-e">片区<span>*</span></div>
          <div class="t-bound-t">
            <van-field
                v-model="showAreaValue"
                name=""
                label=""
                readonly="readonly"
                placeholder="请选择片区"
                @click="showAreaFlag=true"
            >
              <template #right-icon>
                <van-icon name="arrow-down"/>
              </template>
            </van-field>
          </div>
        </div>
      </div>
    </div>
    <div class="card" v-if="userWorkList.length>0">
      <div class="nav-tab-group">
        <div class="tab-item" v-for="(item,index) in userWorkList"
             :class="allCheck?'current':(current===index?'current':'')" :key="index" @click="getTab(item,index)">
          {{ item.name }}
        </div>
      </div>
      <div class="playlist-item" v-for="(item,index) in useObj" :key="index">
        <div class="material-info">
          <!--          <div class="material-name">{{ item.name }} </div>-->
          <div class="material-content">
            <div class="tit"><span class="el-icon-circle-plus"></span>其他加钱与加分项</div>
            <div class="cont">
              <div class="duration-edit">
                <span>金额:</span>
                <div class="durable">
                  <span class="add" @click="getAddMoney(item)">+</span>
                  <van-field class="time-text" type="number" v-model="item.otherAddMoney" @input="onInput(item)"
                             @focus="saveScrollPosition" @change="getOnNumberTime('',item)"></van-field>
                  <span>元</span>
                </div>
              </div>
              <div class="duration-edit">
                <span>分值:</span>
                <div class="durable">
                  <span class="add" @click="getAddScore(item)">+</span>
                  <van-field class="time-text" type="number" v-model="item.otherAddScore" @focus="saveScrollPosition"
                             @change="getOnNumberTime('',item)"></van-field>
                  <span>分</span>
                </div>
              </div>
            </div>
            <div class="cont-clem">
              <span>备注:</span>
              <van-field class="time-text" type="text" placeholder="请输入加分备注说明" v-model="item.otherAddRemark"
                         @focus="saveScrollPosition" @change="getOnNumberTime('',item)"></van-field>
            </div>
          </div>
          <div class="material-content">
            <div class="tit"><span class="el-icon-remove"></span>其他扣钱与扣分项</div>
            <div class="cont">
              <div class="duration-edit">
                <span>金额:</span>
                <div class="durable">
                  <span class="remove" @click="getRemoveMoney(item)">-</span>
                  <van-field class="time-text" type="number" v-model="item.otherMinusMoney" @focus="saveScrollPosition"
                             @change="getOnNumberTime('',item)"></van-field>
                  <span>元</span>
                </div>
              </div>
              <div class="duration-edit">
                <span>分值:</span>
                <div class="durable">
                  <span class="remove" @click="getRemoveScore(item)">-</span>
                  <van-field class="time-text" type="number" v-model="item.otherMinusScore" @focus="saveScrollPosition"
                             @change="getOnNumberTime('',item)"></van-field>
                  <span>分</span>
                </div>
              </div>
            </div>
            <div class="cont-clem">
              <span>备注:</span>
              <van-field class="time-text" type="text" placeholder="请输入扣分备注说明" v-model="item.otherMinusRemark"
                         @focus="saveScrollPosition" @change="getOnNumberTime('',item)"></van-field>
            </div>
          </div>
        </div>
      </div>
      <div class="btn-consume">
        <div class="btn-consume-solid" @click="getOneCommit"><span class="el-icon-s-tools"></span>全部同步</div>
        <div class="btn-consume-solid" @click="getDelCommit"><span class="el-icon-delete-solid"></span>重置</div>
      </div>
    </div>
    <div class="card" v-else>
      <div class="empty-state">
        <div class="empty-icon">📋</div>
        <div class="empty-text">暂无数据</div>
      </div>
    </div>
    <div class="label-button" v-if="userWorkList.length>0">
      <div class="label-commit" @click="getCommit">提交</div>
    </div>

    <!--  片区  -->
    <van-popup v-model="showAreaFlag" position="bottom">
      <van-picker
          show-toolbar
          title="片区"
          :columns="areaItemList"
          value-key="name"
          :default-index="0"
          @confirm="onAreaItemType"
          @cancel="showAreaFlag = false"
      />
    </van-popup>
    <!--  月份  -->
    <van-popup v-model="showMonthFlag" position="bottom">
      <van-picker
          show-toolbar
          title=""
          :columns="monthList"
          value-key="name"
          :default-index="0"
          @confirm="onMonthType"
          @cancel="showMonthFlag = false"
      />
    </van-popup>
    <!--    确认提示-->
    <van-popup v-model="showFlag" round position="center" :close-on-click-overlay="false" :style="{width:'90%' }">
      <div class="inner-diag">
        <div class="title-had">
          <div class="fixed-close" @click="showFlag=false">&times;</div>
          <div class="section-title">
            绩效设置确认
          </div>
        </div>
        <div class="tabs-group">
          <div class="use-item" v-for="(item,index) in userWorkList" :key="index">
            <div class="use-name">{{ item.name }}</div>
            <div class="use-content">
              <div class="use-tit">其他加钱与加分项</div>
              <div class="use-cont">
                <div class="duration-edit">
                  金额:<span>{{ item.otherAddMoney }}</span>元
                </div>
                <div class="duration-edit">
                  分值:<span>{{ item.otherAddScore }}</span>分
                </div>
              </div>
              <div class="use-cont-clem" v-if="item.otherAddRemark">
                <span>备注:{{ item.otherAddRemark }}</span>
              </div>
            </div>
            <div class="use-content">
              <div class="use-tit">其他扣钱与扣分项</div>
              <div class="use-cont">
                <div class="duration-edit">
                  金额:<span>{{ item.otherMinusMoney }}</span>元
                </div>
                <div class="duration-edit">
                  分值:<span>{{ item.otherMinusScore }}</span>分
                </div>
              </div>
              <div class="use-cont-clem" v-if="item.otherMinusRemark">
                <span>备注:{{ item.otherMinusRemark }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="form-buttons">
          <span class="erase" @click="showFlag=false">取消</span>
          <span class="leg" @click="getLastSubmit" v-if="submitFlag">确认</span>
          <span class="leg" @click="getLastSubmitIng" v-else>确认</span>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<style scoped lang="scss">
.tech-content-no {
  font-size: 28px;
  padding: 120px 20px 120px 20px;
  box-sizing: border-box;

  /deep/ .van-cell {
    padding: 15px 20px;
    font-size: 24px !important;

  }

  /deep/ .van-field__control {
    font-size: 24px !important;

  }

  .nav-tab-group {
    //display: flex;
    //flex-flow: row;
    //gap: 10px;
    //padding:0 0 10px 0;
    .tab-item {
      display: inline-block;
      padding: 10px 20px;
      border: 2px solid #e62d2d;
      color: #e62d2d;
      border-radius: 10px;
      margin-bottom: 10px;
      margin-right: 10px;
    }

    .current {
      background: #e62d2d;
      color: #fff;
    }
  }

  .card {
    padding: 20px 30px;
  }

  .label-title {
    font-weight: bold;
    color: var(--primary-color);
    margin-bottom: 15px;
    padding-bottom: 8px;
    padding-left: 8px;
    border-bottom: 2px solid var(--primary-color);
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .rate-gr-title {
    font-weight: bold;
    padding-bottom: 20px;

    span {
      color: red;
    }
  }

  .rate-group {
    display: flex;
    align-items: center;

    span {
      display: inline-block;
      margin-left: 20px;
    }
  }

  .label-group {
    padding-top: 20px;

    .form-row {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px;
      background: transparent;
    }

    .form-group {
      background: transparent;
      padding: 0;
      margin: 0;

      .t-bound {
        margin-bottom: 20px;

        .grant {
          color: transparent;
        }

        .t-bound-e {
          font-weight: bold;
          padding: 0 0 10px;

          span {
            display: inline-block;
            vertical-align: middle;
            margin-left: 10px;
            color: #e62d2d;
          }
        }

        .info-tooltip {
          background: #fff;
          border: 1px solid rgba(230, 45, 45, 0.2);
          border-radius: var(--border-radius-sm);
          padding: 12px;
          margin-bottom: 18px;
          font-size: 13px;
          color: var(--text-light);
          line-height: 1.6;
          box-shadow: var(--shadow-md);
          animation: fadeIn 0.3s ease;
        }

        .info-tooltip-content {
          position: relative;
          padding-left: 15px;
          font-size: 24px;
        }

        .info-tooltip-content:before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          width: 3px;
          background: var(--primary-color);
          border-radius: 2px;
        }

        .t-bound-t {
          display: flex;
          flex-direction: row;
          align-items: center;

          /deep/ .van-cell {
            width: 80%;
            background: #f9f9f9;
            border-radius: 10px;
            margin-right: 20px;
            border: 1px solid rgba(0, 0, 0, 0.1);
          }
        }
      }
    }
  }

  .label-radio {
    padding-top: 20px;

  }

  .finish-group {
    .finish-group-title {
      color: #4caf50;
      padding: 10px 0;
    }

    .finish-group-list {
      .finish-box {
        display: inline-block;
        padding: 5px 0 5px 25px;
        border-radius: 50px;
        background: #4caf50;

        span {
          color: #fff;
        }

        .del {
          font-size: 40px;
          padding: 0 20px 0 30px;
        }
      }
    }
  }

  .label-button-t {
    width: 100%;

    .label-bound {
      width: 100%;
      color: #fff;
      text-align: center;
      height: 80px;
      line-height: 80px;
      border-radius: 10px;
      background: linear-gradient(135deg, #4CAF50, #45a049);
    }
  }

  .stack-group {
    display: flex;
    flex-direction: row;
    gap: 18px;

    .t-bound {
      display: flex;
      flex-direction: column;
      flex: 1;
      margin-bottom: 20px;

      .grant {
        color: transparent;
      }

      .t-bound-e {
        //font-weight: bold;
        padding: 0 0 10px;

        span {
          color: red;
        }
      }

      .t-bound-t {
        display: flex;
        flex-direction: row;
        align-items: center;

        .label-button-t {
          width: 100%;

          .label-bound {
            width: 100%;
            color: #fff;
            text-align: center;
            height: 80px;
            line-height: 80px;
            border-radius: 10px;
            background: linear-gradient(135deg, #4CAF50, #45a049);
          }
        }

        /deep/ .van-cell {
          //width: 80%;
          background: #f9f9f9;
          border-radius: 10px;
          margin-right: 20px;
          border: 1px solid rgba(0, 0, 0, 0.1);
        }
      }
    }
  }

  .label-stack {
    .label-stack-title {
      padding: 10px 0;

      span {
        display: inline-block;
        color: red;
        margin-left: 10px;
      }
    }

    .label-stack-text {
      border: 2px solid #ddd;
      border-radius: 10px;

      /deep/ .van-cell {
        border-radius: 10px;
      }
    }
  }

  .label-button {
    position: fixed;
    left: 0;
    bottom: 0;
    height: 120px;
    padding: 20px 20px 0;
    background: #fff;
    width: 100%;

    .label-commit {
      width: 100%;
      color: #fff;
      text-align: center;
      height: 80px;
      line-height: 80px;
      border-radius: 10px;
      background: linear-gradient(135deg, var(--primary-color), var(--primary-dark));
    }

    .label-bound {
      width: 100%;
      color: #fff;
      text-align: center;
      height: 80px;
      line-height: 80px;
      border-radius: 10px;
      background: linear-gradient(135deg, #4CAF50, #45a049);
    }
  }

}

/deep/ .van-popup {
  background: transparent;
}

.inner-diag {
  height: 100%;
  width: 100%;
  box-sizing: border-box;

  .title-had {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    padding: 40px 20px 0;
    background: #fff;
    border-bottom: 1px solid #e5e7eb;

    .fixed-close {
      position: absolute;
      right: 50px;
      top: 19px;
      font-size: 50px;
      color: #999;
    }

    .section-title {
      font-size: 32px;
      background: #fff;
      padding-left: 10px;
    }
  }

  .form-buttons {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-top: 1px solid #e5e7eb;
    padding: 20px 20px;
    background: #fff;
    margin: 0;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;

    span {
      display: flex;
      justify-content: center;
      flex: 1;
      border: 1px solid #e5e7eb;;
      padding: 20px 35px;
      border-radius: 10px;
    }

    .erase {
      background: #f3f4f6;
      color: #666;
    }

    .leg {
      background: linear-gradient(135deg, var(--primary-color), var(--primary-dark));
      color: white;
    }
  }
}

.btn-consume {
  display: flex;
  flex-flow: row;
  height: 120px;
  padding: 20px 0;
  background: #fff;
  width: 100%;
  gap: 40px;
  justify-content: flex-end;
  .btn-consume-solid {
    //width: 100%;
    text-align: center;
    height: 70px;
    line-height: 70px;
    border-radius: 10px;
    //border: 2px solid #e62d2d;
    color: #999;
    vertical-align: middle;
  }
}

.playlist-item {
  display: flex;
  align-items: center;
  //padding: 12px;
  border-radius: var(--radius-sm);
  //margin-bottom: 8px;
  background: #fff;
}

.material-info {
  flex: 1;
  //padding: 0 20px;
}

.material-content {
  display: flex;
  flex-flow: column;

  .tit {
    padding-top: 20px;
    color: #e62d2d;
    border-bottom: 2px solid red;
  }

  .cont-clem {
    display: flex;
    flex-flow: column;
    //align-items: center;
    //gap: 4px;
    margin-top: 10px;

    .time-text {
      //width: 100%;
      //margin: 0 10px;
      background: #fff;
      border-radius: 10px;
      border: 2px solid rgba(0, 0, 0, 0.1);
    }

    span {
      font-size: 26px;
      font-weight: bold;
      color: var(--text-secondary);
    }
  }

  .cont {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    gap: 20px;

    .duration-edit {
      display: flex;
      flex-flow: column;
      gap: 4px;
      margin-top: 20px;

      span {
        font-weight: bold;
        font-size: 26px;
        color: var(--text-secondary);
      }

      .durable {
        display: flex;
        flex-flow: row;
        align-items: center;
        border-radius: 10px;
        border: 2px solid rgba(0, 0, 0, 0.1);
        flex: 1;
        background: #f9f9f9;

        .time-text {
          width: 80%;
          align-items: center;
          background: #fff;
        }

        span {
          display: flex;
          padding: 0 20px;
          color: var(--text-secondary);
          font-size: 26px;
        }

        .add {
          font-size: 36px;
          color: #e62d2d;
        }

        .remove {
          font-size: 36px;
          color: #25a603;
          //background: #f9f9f9;
        }
      }
    }
  }
}

.material-name {
  font-size: 28px;
  font-weight: 500;
  margin-bottom: 4px;
  word-break: break-word;

  span {
    padding: 4px;
    font-size: 22px;
  }

  .gGeneral {
    background-color: #e3f2fd;
    color: #1976d2;
  }

  .pPersonal {
    background-color: #fff2fd;
    color: #ff9800;
  }
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: var(--text-light);
}

.empty-icon {
  font-size: 68px;
  margin-bottom: 12px;
}

.empty-text {
  font-size: 24px;
}

.inner-diag {
  //display: flex;
  //flex-direction: column;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  border-radius: 30px;

  .title-had {
    //position: fixed;
    //left: 0;
    //top: 0;
    //z-index: 19;
    //height: 100px;
    //width: 100%;
    padding: 40px 50px 10px;
    background: #fff;
    border-bottom: 1px solid #e5e7eb;

    .fixed-close {
      position: absolute;
      right: 50px;
      top: 19px;
      font-size: 50px;
      color: #999;
    }

    .section-title {
      font-size: 32px;
      background: #fff;
    }
  }

  .form-buttons {
    width: 100%;
    display: flex;
    flex-flow: row;
    gap: 40px;
    border-top: 1px solid #e5e7eb;
    text-align: center;
    padding: 30px 40px 40px;
    span {
      display: inline-block;
      border: 1px solid #e5e7eb;;
      padding: 18px 35px;
      border-radius: 10px;
      //margin-right: 20px;
    }

    .erase {
      background: #f3f4f6;
      color: #666;
    }

    .leg {
      background: #e62d2d;//linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
    }
  }

  .tabs-group {
    padding: 30px 30px;
    overflow-y: auto;
    overflow-x: hidden;
    background: #fff;
    text-align: center;

    .use-item {
      display: flex;
      flex-flow: column;
      justify-content: left;
      border-radius: 10px;
      margin-bottom: 20px;
      padding: 20px;
      box-shadow: 0 0.02667rem 0.13333rem rgba(0, 0, 0, 0.15);

      .use-name {
        display: flex;
        justify-content: left;
        font-weight: bold;

      }

      .use-cont {
        display: flex;
        flex-flow: row;

        .duration-edit {
          padding-right: 20px;

          span {
            color: #e62d2d;
            padding: 0 20px;
            font-weight: bold;
          }
        }
      }

      .use-cont-clem {

        display: flex;
        justify-content: left;
      }

      .use-content {
        display: flex;
        flex-flow: column;

        .use-tit {
          display: flex;

        }
      }
    }
  }
}
</style>